// Canonical dependent-relationship options surfaced in every "Add Dependent"
// form (Profile, Onboarding, DependentsList, migration EditDependentModal).
// The DB column (`dependents.relationship`) stays free-text varchar(50) so
// legacy values keep reading, but every NEW pick goes through this list.
//
// Slug convention: `child_*` for child variants so classification helpers that
// substring-match on "child" (see isChildRelationship in
// shared/utils/enrollmentCalculator.ts) catch them automatically.

export const DEPENDENT_RELATIONSHIP_OPTIONS = [
  { value: "spouse",           label: "Spouse" },
  { value: "spouse_ex",        label: "Ex-Spouse" },
  { value: "domestic_partner", label: "Domestic Partner" },
  { value: "child",            label: "Child" },
  { value: "child_step",       label: "Step Child" },
  { value: "child_adopted",    label: "Adopted Child" },
  { value: "child_foster",     label: "Foster Child" },
  { value: "child_ward",       label: "Legal Guardian's Child / Ward" },
  { value: "grandchild",       label: "Grandchild" },
] as const;

export type DependentRelationship =
  typeof DEPENDENT_RELATIONSHIP_OPTIONS[number]["value"];

/**
 * Every value treated as "child" for tier classification and carrier form-fill.
 * Excludes spouse + domestic_partner. Use this when filtering dependents into
 * carrier child slots so step/adopted/foster/ward/grandchild route correctly
 * instead of being dropped by an exact `"child"` match.
 */
export const CHILD_RELATIONSHIP_VALUES = [
  "child",
  "child_step",
  "child_adopted",
  "child_foster",
  "child_ward",
  "grandchild",
] as const satisfies readonly DependentRelationship[];
